module.exports = __webpack_public_path__ + "3b981a737a2af46568389087713e625e.fbx";